import React, { useEffect, useState } from 'react';
export function StickyAlertBar() {
  const [isVisible, setIsVisible] = useState(true);
  // Optional: Hide on scroll down, show on scroll up logic could go here
  // For now, keeping it sticky as requested
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 w-full bg-black text-gold-400 z-50 overflow-hidden py-2 shadow-lg border-b border-gold-600/30" data-id="element-351">
      <div className="whitespace-nowrap animate-marquee font-bold tracking-wider text-sm md:text-base flex items-center" data-id="element-352">
        <span className="mx-4" data-id="element-353">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-354">•</span>
        <span className="mx-4" data-id="element-355">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-356">•</span>
        <span className="mx-4" data-id="element-357">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-358">•</span>
        <span className="mx-4" data-id="element-359">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-360">•</span>
        <span className="mx-4" data-id="element-361">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-362">•</span>
        <span className="mx-4" data-id="element-363">🔥 SOLO POR HOY +7 BONOS GRATIS 🔥</span>
        <span className="mx-4 text-white" data-id="element-364">•</span>
      </div>
    </div>;
}